import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "upload"]
  connect() { this.toggle() }
  toggle() { this.uploadTarget.hidden = !this.checkboxTarget.checked }
}
